import React from 'react';
import './SectionHeader.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const SectionHeader = ({ title, subtitle, paragraph, titleSize, buttonLink, buttonName }) => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768;
   // Function to check if the link is internal or external
  const isInternalLink = link => link.startsWith('/');

  if (!titleSize) {
    if (isMobile) titleSize = "1.8rem";
    else { titleSize = "3rem" }
  } else {
    if (isMobile) titleSize = "1.8rem";
  }

  return (
    <div className="section-header">
      <h1 className="title" style={{ color: '#28588F', fontSize: titleSize }}>{t(title)}</h1>
      <p className="subtitle">{t(subtitle)}</p>
      <p className="paragraph">{t(paragraph)}</p>
      {buttonName && buttonLink && (
        // Render either Link or anchor tag based on link type
        isInternalLink(buttonLink) ? (
          <Link to={buttonLink} className="ImageText-button">{t(buttonName)}</Link>
        ) : (
          <a href={buttonLink} className="ImageText-button" target='_blank'>{t(buttonName)}</a>
        )
      )}
    </div>
  );
};

export default SectionHeader;
